import { Box, Chip, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { ECommerceOfferResponse } from "../../eCommerce/eCommerceApi";

interface Props {
  readonly offer: ECommerceOfferResponse;
  readonly tripDateRange: string | null;
  readonly url: string | null;
}

const ECommerceOfferHeader: FC<Props> = ({ offer, tripDateRange, url }) => {
  return (
    <Box sx={{ height: 320, width: "100%", position: "relative" }}>
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 60%, transparent 100%)",
        }}
      />
      <Box sx={{ position: "absolute", bottom: 0, left: 0, right: 0, p: 4, color: "#fff" }}>
        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
          <Chip
            label={`Oferta ${offer.id.userFriendly}`}
            size="small"
            sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "#fff", fontWeight: "bold", backdropFilter: "blur(4px)" }}
          />
          <Chip
            label="Gotowa do sprzedaży"
            size="small"
            sx={{ bgcolor: "primary.main", color: "#fff", fontWeight: "bold" }}
          />
          {tripDateRange && (
            <Chip
              label={tripDateRange}
              size="small"
              sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "#fff", fontWeight: 600, backdropFilter: "blur(4px)" }}
            />
          )}
        </Stack>
        <Typography
          variant="h3"
          sx={{ textShadow: "0 2px 4px rgba(0,0,0,0.3)", mb: 0.5, letterSpacing: "-0.5px", fontWeight: "bold" }}
        >
          {offer.name}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            opacity: 0.9,
            fontWeight: "normal",
            whiteSpace: "pre-line",
          }}
        >
          {offer.info}
        </Typography>
      </Box>
    </Box>
  );
};

export default ECommerceOfferHeader;
